export default {

    title: "Cargando...",

    responses: {
        "404": {
            title: "Se produjo un error",
            header: "Se produjo un error",
            message: "No se encontró un token válido. Es posible que su token haya caducado."
        },
        "200": {
            title: "Éxito",
            header: "Éxito",
            message: "Su solicitud se ha procesado correctamente."
        },
        "200_tfalogin": {
            title: "Verificación de inicio de sesión",
            header: "@:views.tunnel.service.responses.200_tfalogin.title",
            message: "El inicio de sesión ha sido verificado."
        },
        "404_tfalogin": {
            title: "Verificación de inicio de sesión",
            header: "@:views.tunnel.service.responses.404_tfalogin.title",
            message: "No se encontró un token válido. Es posible que su token haya caducado."
        },
        "200_tfaaddress": {
            title: "Verificación de domicilio",
            header: "@:views.tunnel.service.responses.200_tfaaddress.title",
            message: "Gracias por verificar tu dirección. Ahora puedes seleccionarla como dirección de envío al realizar tu pedido."
        },
        "404_tfaaddress": {
            title: "Verificación de domicilio",
            header: "@:views.tunnel.service.responses.404_tfaaddress.title",
            message: "No se encontró un token válido. Es posible que su token haya caducado."
        },
        "201_delivery": {
            title: "Gracias",
            header: "Gracias",
            message: "Gracias por su respuesta."
        },
        "201_shipment_received": {
            title: "Gracias",
            header: "Gracias",
            message: "Gracias por su respuesta."
        },
        "400": {
            title: "Solicitud incorrecta. Se ha producido un error.",
            header: "@:views.tunnel.service.responses.400.title",
            message: "Solicitud incorrecta. Se ha producido un error."
        }
    }
}